import clsx from 'clsx'

export default function AudioIndicator({ isMuted = false, isActive = false }) {
  if (isMuted) {
    return (
      <div className="px-2 py-1 glass rounded-lg flex items-center gap-2">
        <span className="text-danger text-lg">🔇</span>
      </div>
    )
  }

  if (isActive) {
    return (
      <div className="px-2 py-1 glass rounded-lg flex items-center gap-2">
        <div className="flex gap-0.5 h-4 items-end">
          <div className="w-0.5 bg-success rounded-sm animate-audio-wave" style={{ animationDelay: '0s' }} />
          <div className="w-0.5 bg-success rounded-sm animate-audio-wave" style={{ animationDelay: '0.1s' }} />
          <div className="w-0.5 bg-success rounded-sm animate-audio-wave" style={{ animationDelay: '0.2s' }} />
          <div className="w-0.5 bg-success rounded-sm animate-audio-wave" style={{ animationDelay: '0.3s' }} />
        </div>
      </div>
    )
  }

  return null
}
